import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { changeSaveCriteriaPopup } from '../../common/store/slice'
import { selectSelectedIndicatorCount } from '../store/slice'
import classes from './index.module.scss'

export const SaveCriteria = () => {
  const dispatch = useDispatch()
  const selectedIndicatorCount = useSelector(selectSelectedIndicatorCount)

  const handleClick = () => {
    if (!selectedIndicatorCount) return

    dispatch(
      changeSaveCriteriaPopup({
        isShow: true,
      }),
    )
  }

  return (
    <Element
      elementName="span"
      className={classes.headerBtn}
      style={{ color: selectedIndicatorCount ? '' : '#9C9C9C' }}
      onClick={handleClick}
    >
      <Translate value="screening.SAVE_CRITERIA" />
    </Element>
  )
}
